import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { notify } from '../../../utils/notification';
import { decideDefenderReaction } from '../utils/combatSaveStateService';

export const SUPERIOR_HUNTERS_DEFENSE = 'ranger:hunter:superior-hunters-defense';

/**
 * Superior Hunter's Defense (Hunter 15) when an attack hits: use the Reaction for Resistance to that damage and any other
 * damage of the same type until the end of the turn. A Monk's Deflect Attacks prompt and Stone's Endurance prompt handle
 * offers that include them.
 */
export default function SuperiorHuntersDefensePrompt({ campaignId, characterId, combatState, onCombatChange }) {
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const offer = (combatState?.reactionOpportunities || []).find((o) => o.status === 'pending' && String(o.targetCombatantId) === String(characterId)
    && o.candidateFeatures?.includes(SUPERIOR_HUNTERS_DEFENSE) && !o.candidateFeatures.includes('monk:deflect-attacks') && !o.candidateFeatures.includes('species:stones-endurance') && !o.candidateFeatures.includes('spell:shield'));
  const decide = async (decision, featureId = SUPERIOR_HUNTERS_DEFENSE) => {
    if (lock.current || !offer) return;
    lock.current = true; setBusy(true);
    try {
      const result = await decideDefenderReaction(campaignId, offer.opportunityId, decision, featureId);
      onCombatChange?.(result.combat);
    } catch (error) { notify(error.message || 'Reaction could not be saved.', 'danger'); }
    finally { lock.current = false; setBusy(false); }
  };
  const types = (offer?.damageTypes || []).join(', ');
  return (
    <Modal show={Boolean(offer)} centered backdrop="static" keyboard={false} className="dnd-modal modern-modal" aria-label="Superior Hunter's Defense">
      <Modal.Header><Modal.Title>Superior Hunter&apos;s Defense</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>{offer?.rawDamage ? `An attack hit you for ${offer.rawDamage}${types ? ` ${types}` : ''} damage.` : 'An attack hit you.'}</p>
        <p>Use your Reaction to gain Resistance to that damage, and any other damage of the same type until the end of this turn?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={busy} onClick={() => decide('skip')}>Skip</Button>
        {offer?.candidateFeatures?.includes('rogue:uncanny-dodge') && (
          <Button variant="outline-light" disabled={busy} onClick={() => decide('use', 'rogue:uncanny-dodge')}>Uncanny Dodge instead</Button>
        )}
        <Button disabled={busy} onClick={() => decide('use')}>{busy ? 'Saving…' : "Use Superior Hunter's Defense"}</Button>
      </Modal.Footer>
    </Modal>
  );
}
